module.exports = function() {
  return new Worker(__webpack_public_path__ + "static/js/384ee8b7ba74c5c13966.worker.js");
};